import { ColDef } from "ag-grid-community";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IRoleAndPermission  } from "../../services/user-role-administration-service/Models";
import { Theme } from "@mui/material";

const projectRow = (
    entry: IRoleAndPermission): RowDef => {

    let row: RowDef = {
    };

    row['roleName'] =  entry.roleName;
    row['group'] = entry.group;
    row['permissionType'] = entry.permissionType;
    row['read'] = entry.read;
    row['write'] = entry.write;
    row['execute'] = entry.execute;
    row['manualEdit'] = entry.manualEdit;
    row['liveData'] = entry.liveData;
    row['control'] = entry.control;
    row['disable'] = entry.disable;

    return row;
}

const RolePermissionsReportUtils = {

    createGridRows: function (entries: IRoleAndPermission[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.map((o) => {

            return projectRow(o);

        }) ?? [];

        return rows;
    },
    createGridColumns: function (theme: Theme): ColDef[] {

        let cols: ColDef[] = [{
            headerName: i18n.t("permissionReport.roleName") as string,
            field: 'roleName',
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.group") as string,
            field: 'group',
            maxWidth: 148,
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.permissionType") as string,
            field: 'permissionType',
            sortable: true,
            //flex: 1,
            minWidth: 200,
            type: "text, multiline"
        }, {
            headerName: i18n.t("permissionReport.read") as string,
            field: 'read',
            maxWidth: 128,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.write") as string,
            field: 'write',
            maxWidth: 138,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.execute") as string,
            field: 'execute',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.manualEdit") as string,
            field: 'manualEdit',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.liveData") as string,
            field: 'liveData',
            maxWidth: 148,
            type: "text"            
        }, {
            headerName: i18n.t("permissionReport.control") as string,
            field: 'control',
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("permissionReport.disable") as string,
            field: 'disable',
            maxWidth: 148,
            type: "text"
        }];

        return cols;
    },
};

export default RolePermissionsReportUtils;
